import { render } from "./Mypage.vue?vue&type=template&id=2fc4225a"
import script from "./Mypage.vue?vue&type=script&lang=js"
export * from "./Mypage.vue?vue&type=script&lang=js"

import "./Mypage.vue?vue&type=style&index=0&id=2fc4225a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__